import client from "./client";

export interface TwoFactorStatus {
  isEnabled: boolean;
  hasBackupCodes: boolean;
}

export interface TwoFactorSetupResponse {
  qrCodeDataUrl: string;
  secret: string;
  backupCodes: string[];
}

export const getTwoFactorStatus = async (): Promise<TwoFactorStatus> => {
  return await client
    .get("/2fa/status")
    .then(response => response.data.response);
};

export const setupTwoFactor = async (): Promise<TwoFactorSetupResponse> => {
  return await client
    .post("/2fa/setup")
    .then(response => response.data.response);
};

export const verifyTwoFactorSetup = async (
  code: string
): Promise<{ message: string }> => {
  return await client
    .post("/2fa/verify-setup", { code })
    .then(response => response.data.response);
};

export const regenerateBackupCodes = async (
  code: string
): Promise<{ backupCodes: string[] }> => {
  return await client
    .post("/2fa/regenerate-backup-codes", { code })
    .then(response => response.data.response);
};
